var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTelegramLogo = function SvgIconTelegramLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20.067 2.48a1.75 1.75 0 0 1 2.34 2.013l-.001.005-3.525 15.394a1.752 1.752 0 0 1-2.865.92l-3.513-3.091-2.256 2.256-.004.003a1.75 1.75 0 0 1-2.993-1.228v-5.286l-4.194-.842h-.004c-1.678-.345-1.943-2.7-.295-3.346l17.306-6.796zM9.25 14.86l1.748 1.538-1.748 1.748zm3.892.76-.046-.04-3.245-2.855 10.328-7.46-3.154 13.772zm1.613-8.904L4.278 10.83l3.74.75z",
    clipRule: "evenodd"
  })));
};
export default SvgIconTelegramLogo;